import { ReactNode } from 'react';
import { IcomxChatContext } from './IcomxChatContext';
import IcomxChatProvider from './IcomxChatProvider';
import { useIcomxAvailability } from './useIcomxAvailability';

interface AuthenticatedIcomxChatProviderProps {
  children: ReactNode;
}

const DISABLED_ICOMX_CONTEXT = {
  isEnabled: false,
  isLoading: false,
  isLaunching: false,
  openResourceConversation: () => undefined,
};

export function canRenderIcomx(status: { isLoggedIn?: boolean; hasCompletedLoginSetup?: boolean } | null | undefined) {
  return !!status?.isLoggedIn && !!status?.hasCompletedLoginSetup;
}

export default function AuthenticatedIcomxChatProvider({ children }: AuthenticatedIcomxChatProviderProps) {
  const availability = useIcomxAvailability();

  if (!canRenderIcomx(availability)) {
    return (
      <IcomxChatContext.Provider value={DISABLED_ICOMX_CONTEXT}>
        {children}
      </IcomxChatContext.Provider>
    );
  }

  return <IcomxChatProvider>{children}</IcomxChatProvider>;
}